export default "__VITE_ASSET__98554963__"